<template>
  <!-- Компонент вопрос -->
  <QuizQuestion :question="question" />
  <!-- Компонент вопрос -->

  <div class="question-display-container">

    <div class="quiz-options quiz__multiple-choice-list">
      <label
        v-for="(option, optionIndex) in question.options"
        :key="optionIndex"
        class="quiz__option"
        :class="{
          'checked': isSelected(optionIndex),
          'correct': showResults && isCorrect(optionIndex),
          'incorrect': showResults && isSelected(optionIndex) && !isCorrect(optionIndex),
          'disabled': showResults
        }"
        @click="!showResults && toggleOption(optionIndex)"
      >
        <span>{{ option.text || option }}</span>
        <div class="quiz__custom-checkbox">
          <input
            type="checkbox"
            :checked="isSelected(optionIndex)"
            :disabled="showResults"
            @change="toggleOption(optionIndex)"
          />
          <div class="quiz__checkbox-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
              <path d="M1 5L4.33333 8.5L11 1.5" stroke="white" stroke-width="2" stroke-linecap="round"></path>
            </svg>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import QuizQuestion from "@/components/QuizQuestion/QuizQuestion.vue";

export default {
  name: 'MultipleChoiceTextQuestion',
  components: {
    QuizQuestion
  },
  props: {
    question: {
      type: Object,
      required: true,
      validator: (value) => {
        return (
          value &&
          typeof value.question_text === 'string' &&
          Array.isArray(value.options)
        );
      }
    },
    selectedAnswers: { // Array of selected option indices
      type: Array,
      default: () => []
    },
    showResults: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answers-updated'], // Emitting an array of answers
  methods: {
    isSelected(optionIndex) {
      return this.selectedAnswers.includes(optionIndex);
    },
    isCorrect(optionIndex) {
      // Check if this option should be correct
      if (this.question.options[optionIndex] && typeof this.question.options[optionIndex] === 'object') {
        return this.question.options[optionIndex].isCorrect === true;
      }
      // Fallback to correct_options array if available
      return this.question.correct_options && this.question.correct_options.includes(optionIndex);
    },
    toggleOption(optionIndex) {
      if (this.showResults) return;

      const newSelectedAnswers = [...this.selectedAnswers];
      const indexInSelected = newSelectedAnswers.indexOf(optionIndex);

      if (indexInSelected > -1) {
        newSelectedAnswers.splice(indexInSelected, 1); // Deselect
      } else {
        newSelectedAnswers.push(optionIndex); // Select
      }
      this.$emit('answers-updated', this.question.id, newSelectedAnswers);
    }
  }
};
</script>

<style lang="scss">
.quiz-options.quiz__multiple-choice-list {
  display: flex;
  flex-direction: column;
  gap: 12px;

  & .quiz__option {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 12px;
    padding: 20px;
    border: 1px solid transparent;
    transition: $duration $timing-function;
    cursor: pointer;

    &.disabled {
      cursor: not-allowed;
      opacity: 0.4;
    }

    &.checked {
      opacity: 1;
    }

    & .quiz__custom-checkbox {
      position: relative;
      flex-shrink: 0;

      input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
      }

      .quiz__checkbox-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        border-radius: 4px;
        border: 1px solid var(--gray, #AAA);
        opacity: 0.5;
        background-color: transparent;
        transition: $duration $timing-function;

        svg {
          opacity: 0;
          transition: $duration $timing-function;
        }
      }

      input[type="checkbox"]:checked + .quiz__checkbox-icon {
        background-color: var(--dark-gray);
        border-color: var(--dark-gray);
        opacity: 1;

        svg {
          opacity: 1;
        }
      }
    }
  }
}
</style>
